import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ISteps} from "@edp-pages/requests-and-operations/services/ISteps";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";

export enum Step {
    service    = 1,
    attachment = 2,
    timeSlot   = 3,
}

@Injectable({ providedIn: "root" })
export class StepsService implements ISteps {
    private initialSteps = [Step.service, Step.attachment];
    private currentStep: BehaviorSubject<number> = new BehaviorSubject(Step.service);
    private steps: BehaviorSubject<number[]> = new BehaviorSubject(this.initialSteps);
    private advanceButtonAvailable: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private readonly newModalService: NewModalService) {}

    getAdvanceButtonAvailabilityBS(): BehaviorSubject<boolean> {
        return this.advanceButtonAvailable;
    }

    getSteps(): BehaviorSubject<number[]> {
        return this.steps;
    }

    getCurrentStep(): BehaviorSubject<number> {
        return this.currentStep;
    }

    backStep() {
        this.currentStep.next(this.currentStep.value - 1);
    }

    setCurrentStep(step?: number): number {
        this.setAdvanceStepButtonAvailability(false);
        if (this.currentStep.value === Step.attachment) {
            this.newModalService.showSubmitModal();
        } else if (step) {
            this.currentStep.next(step);
        } else if (this.currentStep.value < this.getSteps().value.length) {
            this.currentStep.next(this.currentStep.value + 1);
        }

        return this.currentStep.value;
    }

    setAdvanceStepButtonAvailability(available: boolean) {
        this.advanceButtonAvailable.next(available);
    }

    setTotalSteps(steps: number) {
        if (steps > Step.attachment) {
            const totalSteps = Array.from({length: steps}, (u, val) => val + 1);
            this.steps.next(totalSteps);
        }
    }

    removeStep() {
        if (this.steps.value.length > 2) {
            this.steps.value.pop();
            this.steps.next(this.steps.value);
        }
    }

    resetStep() {
        this.steps.next(this.initialSteps);
        this.currentStep.next(1);
    }
}
